export default "__VITE_ASSET__CAKzkHl$__"